// Build-time SVG renderer for research charts. CommonJS so both React
// (dangerouslySetInnerHTML) and the Node PNG script (sharp) render identical charts.
const INK = "#0b1b2b";
const BLUE = "#1e6bff";
const GRID = "#dfe6ef";
const AXIS = "#8a97a8";
const LABEL = "#3a4656";

function esc(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function fmt(v) {
  const n = Number(v);
  return Number.isInteger(n) ? String(n) : String(Math.round(n * 10) / 10);
}

function niceCeil(v) {
  if (v <= 0) return 1;
  const mag = Math.pow(10, Math.floor(Math.log10(v)));
  const n = v / mag;
  let nice;
  if (n <= 1) nice = 1;
  else if (n <= 2) nice = 2;
  else if (n <= 2.5) nice = 2.5;
  else if (n <= 5) nice = 5;
  else nice = 10;
  return nice * mag;
}

function chartSvg(chart, opts) {
  const W = (opts && opts.width) || 600;
  const H = (opts && opts.height) || 400;
  const rows = (chart && chart.rows) || [];
  const padL = 48;
  const padR = 20;
  const padT = 56;
  const padB = 48;
  const plotW = W - padL - padR;
  const plotH = H - padT - padB;
  const maxV = Math.max(1, ...rows.map((r) => Number(r.value) || 0));
  const niceMax = niceCeil(maxV);
  const title = esc((chart && chart.title) || "");
  const unit = esc((chart && chart.unit) || "");
  const ticks = 4;
  let body = "";

  for (let i = 0; i <= ticks; i++) {
    const y = padT + plotH - (plotH * i) / ticks;
    const val = (niceMax * i) / ticks;
    body += `<line x1="${padL}" y1="${y.toFixed(1)}" x2="${W - padR}" y2="${y.toFixed(1)}" stroke="${GRID}" stroke-width="1"/>`;
    body += `<text x="${padL - 8}" y="${(y + 4).toFixed(1)}" text-anchor="end" font-size="11" fill="${AXIS}">${fmt(val)}</text>`;
  }

  if (chart && chart.type === "line") {
    const n = rows.length;
    const step = n > 1 ? plotW / (n - 1) : 0;
    const pts = rows.map((r, i) => {
      const x = padL + (n > 1 ? step * i : plotW / 2);
      const y = padT + plotH - (plotH * (Number(r.value) || 0)) / niceMax;
      return [x, y];
    });
    const poly = pts.map((p) => `${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(" ");
    body += `<polyline fill="none" stroke="${BLUE}" stroke-width="3" points="${poly}"/>`;
    pts.forEach((p, i) => {
      body += `<circle cx="${p[0].toFixed(1)}" cy="${p[1].toFixed(1)}" r="4" fill="${BLUE}"/>`;
      body += `<text x="${p[0].toFixed(1)}" y="${(p[1] - 10).toFixed(1)}" text-anchor="middle" font-size="11" fill="${INK}" font-weight="600">${esc(fmt(rows[i].value))}</text>`;
      body += `<text x="${p[0].toFixed(1)}" y="${(padT + plotH + 18).toFixed(1)}" text-anchor="middle" font-size="11" fill="${LABEL}">${esc(rows[i].label)}</text>`;
    });
  } else {
    const n = Math.max(1, rows.length);
    const band = plotW / n;
    const bw = band * 0.62;
    rows.forEach((r, i) => {
      const v = Number(r.value) || 0;
      const bh = plotH * (v / niceMax);
      const x = padL + band * i + (band - bw) / 2;
      const y = padT + plotH - bh;
      body += `<rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${bw.toFixed(1)}" height="${bh.toFixed(1)}" rx="4" fill="${BLUE}"/>`;
      body += `<text x="${(x + bw / 2).toFixed(1)}" y="${(y - 8).toFixed(1)}" text-anchor="middle" font-size="11" fill="${INK}" font-weight="600">${esc(fmt(v))}</text>`;
      body += `<text x="${(x + bw / 2).toFixed(1)}" y="${(padT + plotH + 18).toFixed(1)}" text-anchor="middle" font-size="11" fill="${LABEL}">${esc(r.label)}</text>`;
    });
  }

  body += `<line x1="${padL}" y1="${padT + plotH}" x2="${W - padR}" y2="${padT + plotH}" stroke="${AXIS}" stroke-width="1.5"/>`;
  const header =
    `<text x="${padL}" y="26" font-size="16" font-weight="700" fill="${INK}">${title}</text>` +
    (unit ? `<text x="${padL}" y="44" font-size="12" fill="${AXIS}">${unit}</text>` : "");

  return `\n<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" role="img" aria-label="${title}" font-family="Arial, Helvetica, sans-serif"><rect width="${W}" height="${H}" fill="#ffffff"/>${header}${body}</svg>`;
}

module.exports = { chartSvg };
